import i18n from '@/i18n.js'

const state = {
  selectedHospital: localStorage.getItem('hospital'),
  serverName: null,
  locale: i18n.locale
}

const getters = {
  IS_SELECTED_HOSPITAL: state => !!state.selectedHospital,
  SELECTED_HOSPITAL: state => state.selectedHospital,
  HAS_SERVER_NAME: state => !!state.serverName,
  SERVER_NAME: state => state.serverName,
  LOCALE: state => state.locale
}

const actions = {
  SET_HOSPITAL({ commit, state }, hospitalId) {
    if (+hospitalId === +state.selectedHospital) {
      return
    }
    localStorage.setItem('hospital', hospitalId)
    commit('SET_SELECTED_HOSPITAL', hospitalId)
  },
  RESET_HOSPITAL({ commit }) {
    localStorage.removeItem('hospital')
    commit('RESET_SELECTED_HOSPITAL')
  },
  UPDATE_SERVER_NAME({ commit }, name) {
    commit('SET_SERVER_NAME', name)
  },
  UPDATE_LOCALE({ commit }, locale) {
    commit('SET_LOCALE', locale)
  }
}

const mutations = {
  SET_SELECTED_HOSPITAL(state, hospitalId) {
    state.selectedHospital = hospitalId
  },
  RESET_SELECTED_HOSPITAL(state) {
    state.selectedHospital = null
  },
  SET_SERVER_NAME(state, name) {
    state.serverName = name
  },
  SET_LOCALE(state, locale) {
    state.locale = locale
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
